<template>
  <div class="search" :class="showSearchInput ? 'active' : ''">
    <span class="title" @click="showSearchInput = !showSearchInput">BUSCAR AUTOR</span>

    <edi-autocomplete :items="searchResults" :placeholder="placeholder" @input="searchText"/>
  </div>
</template>

<script>
  import EdiAutocomplete from '../components/EdiAutocomplete';
  import {mapGetters, mapActions} from 'vuex';
  import debounce from 'lodash.debounce';

  export default {
    name: 'edi-searcher',
    props: {
      placeholder: String,
      showSearchInput: Boolean
    },
    components: { EdiAutocomplete },
    computed: {
      ...mapGetters(['searchResults']),
    },
    methods: {
      ...mapActions([
        'search',
        'resetSearch'
      ]),
      searchText: debounce(function (text) {
        if (text?.length > 3) {
          this.search(text);
        } else {
          this.resetSearch();
        }
      }, 400)
    }
  }
</script>